import checkFF from '@webapp-next/lib/feature-flag';
import { tabHighlight, showSideTeamStatusBar, linkLauncher } from './helpers';
import { createWebappRoute, getRouter } from '../helpers';

export default [
  // 'marketplace_global': 'marketplaceGlobal',
  createWebappRoute({
    path: '/marketplace_global',
    name: 'marketplace_global-module',
    component() {
      const router = getRouter();
      console.log('ROUTER, marketplace_global');
      // TODO: check why this route exist??
      // await this.marketplace('');
      router.push({ name: 'marketplace-module' });
      router.replace({ name: 'marketplace_global-module' });
      return {};
    },
  }),
  // 'marketplace': 'marketplace',
  createWebappRoute({
    path: '/marketplace',
    name: 'marketplace-module',
    component() {
      console.log('ROUTER, marketplace');

      if ($dt.objConfig.IsFreemium) {
        $dt.toggleFreemiumUpgradeModal('template-payroll-integrations');
        return false;
      }
      if (checkFF('mi-177-new-app-dir-ui-toggle')) {
        tabHighlight('marketplace');
        showSideTeamStatusBar(false);

        const event = new CustomEvent('marketplace', {
          detail: {
            global: true,
            lid: location,
          },
        });

        const vwApp = linkLauncher(
          'exec/devapp/marketplace/marketplace',
          'Marketplace',
          'marketplace',
          null,
          null,
          event
        );

        if (vwApp === true) {
          $dt.objCurrentApp.win.dispatchEvent(event);
        }
      } else {
        getRouter().push({ name: 'home-module' });
      }

      return {};
    },
  }),
];
